<template>
    <div>
        <div :title="'Oppdatert ' + loadDateFromNow">
            Oppdatert {{loadDateFromNow}}
            <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                    <button v-bind="attrs" v-on="on" class="fas fa-redo" :class="loading ? 'fa-spin' : ''" @click="getData(true)"></button>
                </template>
                <span>Oppdater</span>
            </v-tooltip>
        </div>
        <div v-for="team in teamData">
            <h1>{{team.name}}</h1>
            <v-row>
                <v-col>
                    <h2 class="justify-center d-flex">Radar</h2>
                    <chart type="radar" v-if="team.radarChartData" :data="team.radarChartData" :options="{scale:{ gridLines: {color:'gray'}, angleLines:{color:'gray'}}, responsive:true,legend: {display:true}}"></chart>
                </v-col>
                <v-col>
                    <h2 class="justify-center d-flex">Fakturerbare timer</h2>
                    <chart type="line" v-if="team.lineChartData" :data="team.lineChartData" :options="{responsive:true,legend: {display:true}}"></chart>
                </v-col>
            </v-row>
            
            <v-simple-table>
                <template v-slot:default>
                    <thead>
                    <tr>
                        <th class="text-left">Navn</th>
                        <th class="text-right">
                            Timer for siste
                            <br>
                            30 dager / {{totalBusinessDays}} arbeidsdager
                            <br>
                            Fakturerbare
                        </th>
                        <th class="text-right">
                            Timer for siste
                            <br>
                            7 dager / {{weekBusinessDays}} arbeidsdager
                            <br>
                            Fakturerbare
                        </th>
                        <th class="text-right" title="Arbeidsdager siste 30 dager / siste uke">Jobbet antall dager</th>
                        <th class="text-right">Timer ført igår</th>
                        <th class="text-right">Timer ført idag</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="userId in team.users" :key="userId">
                        <td>
                            <v-avatar class="ma-3">
                                <v-img :src="users[userId].wrike.avatarUrl"></v-img>
                            </v-avatar>
                            {{users[userId].wrike.firstName}} {{users[userId].wrike.lastName}}
                        </td>
                        <td class="text-right">
                            {{users[userId].total}} / {{users[userId].totalPerDay | round}} per dag
                            <br> {{users[userId].totalTimeBuckets[0]+users[userId].totalTimeBuckets[1]}} fakturerbare
                        </td>
                        <td class="text-right">
                            {{users[userId].week}} / {{users[userId].weekPerDay | round}} per dag
                            <br> {{users[userId].weekTimeBuckets[0]+users[userId].weekTimeBuckets[1]}} fakturerbare
                        </td>
                        <td class="text-right" title="I siste 30 dager / I siste 7 dager">
                            {{users[userId].totalDays}} / {{users[userId].weekDays}}
                        </td>
                        <td class="text-right" :class="users[userId].yesterday >= 7.5 ? 'success--text' : 'error--text'">
                            {{users[userId].yesterday}}
                        </td>
                        <td class="text-right" :class="users[userId].today >= 7.5 ? 'success--text' : 'error--text'">
                            {{users[userId].today}}
                        </td>
                    </tr>
                    <tr>
                        <td class="text-right font-weight-bold">Sum:</td>
                        <td class="text-right">
                            {{team.total}}
                            / {{team.totalPerDay | round}} per dag
                        </td>
                        <td class="text-right">
                            {{team.week}}
                            / {{team.weekPerDay | round}} per dag
                        </td>
                        <td class="text-right">{{team.totalDays}} / {{team.weekDays}}</td>
                        <td class="text-right">
                            {{team.yesterday}}
                        </td>
                        <td class="text-right">
                            {{team.today}}
                        </td>
                    </tr>
                    <tr>
                        <td class="text-right font-weight-bold">Avg:</td>
                        <td class="text-right">
                            {{team.total | avg(team.users.length)}}
                            / {{team.totalPerDay | avg(team.users.length)}} per dag
                        </td>
                        <td class="text-right">
                            {{team.week | avg(team.users.length)}}
                            / {{team.weekPerDay | avg(team.users.length)}} per dag
                        </td>
                        <td class="text-right">{{team.totalDays | avg(team.users.length)}} / {{team.weekDays | avg(team.users.length)}}</td>
                        <td class="text-right">
                            {{team.yesterday | avg(team.users.length)}}
                        </td>
                        <td class="text-right">
                            {{team.today | avg(team.users.length)}}
                        </td>
                    </tr>
                    </tbody>
                </template>
            </v-simple-table>
        </div>
    </div>
</template>
<script>
    import api from "../api"
    import moment from 'moment'
    import Chart from "@/components/Chart.vue"
    import tasksMixin from '@/mixins/tasks'
    
    export default {
        name: 'Teams',
        components: {Chart},
        mixins: [tasksMixin],
        data(){
            return {
                today: moment().format("YYYY-MM-DD"),
                tomorrow: moment().subtract(1, 'day').format("YYYY-MM-DD"),
                teams: [],
                users: {},
                start: moment().subtract(30, 'day').startOf('day'),
                end: moment().add(1, 'day').startOf('day'),
                loaded: '',
                loading: false
            }
        },
        filters: {
            round(total){ return Math.round(total * 100) / 100},
            avg(total, size){ return Math.round(total / size * 100) / 100 },
            perTotal(total, days){ return Math.round(total / days * 100) / 100},
            perWeek(total, days){ return Math.round(total / days * 100) / 100},
        },
        computed: {
            loadDateFromNow(){
                if(!this.loaded) return null
                return moment(this.loaded, "DD.MM.YYYY HH:mm:ss").fromNow()
            },
            getDateLabels(){
                let date = this.start.clone()
                let dateArr = []
                while(this.end.diff(date, 'day') > 0){
                    dateArr.push(date.format('DD.MM.YYYY'))
                    date.add(1, 'day')
                }
                return dateArr
            },
            totalBusinessDays(){
                let date = this.start.clone()
                let businessDates = 0
                while(this.end.diff(date, 'day') > 0){
                    if(date.isoWeekday() < 6) businessDates++
                    date.add(1, 'day')
                }
                return businessDates
            },
            weekBusinessDays(){
                let date = this.end.clone().subtract(7, 'days')
                let businessDates = 0
                while(this.end.diff(date, 'day') > 0){
                    if(date.isoWeekday() < 6) businessDates++
                    date.add(1, 'day')
                }
                return businessDates
            },
            teamData(){
                if(this.teams.length > 0){
                    for(let t in this.teams){
                        let team = this.teams[t]
                        
                        team.totalPerDay = 0.0
                        team.total = 0.0
                        team.totalDays = 0
                        team.weekPerDay = 0.0
                        team.week = 0.0
                        team.weekDays = 0
                        team.yesterday = 0.0
                        team.today = 0.0
                        
                        for(let u in team.users){
                            let user = this.users[team.users[u]]
                            if(user){
                                let trackedDays = user.timelogs.map(t => moment(t.trackedDate, 'YYYY-MM-DD')).filter(date => date.isoWeekday() < 6).map(date => date.format("DD.MM.YYYY"))
                                user.totalDays = new Set(trackedDays).size
                                user.total = user.timelogs.map(t => t.hours).reduce(this.add, 0.0)
                                let trackedWeekDays = user.timelogs.filter(t => this.isLastWeek(t.trackedDate)).map(t => moment(t.trackedDate, 'YYYY-MM-DD')).filter(date => date.isoWeekday() < 6).map(date => date.format("DD.MM.YYYY"))
                                user.weekDays = new Set(trackedWeekDays).size
                                user.week = user.timelogs.filter(t => this.isLastWeek(t.trackedDate)).map(t => t.hours).reduce(this.add, 0.0)
                                user.yesterday = user.timelogs.filter(t => this.tomorrow === t.trackedDate).map(t => t.hours).reduce(this.add, 0.0)
                                user.today = user.timelogs.filter(t => t.trackedDate === this.today).map(t => t.hours).reduce(this.add, 0.0)
                                
                                user.totalTimeBuckets = []
                                for(let i in this.taskTypes){
                                    user.totalTimeBuckets.push(user.timelogs.filter(t => this.getTaskType(t.taskId) == this.taskTypes[i]).map(t => t.hours).reduce(this.add, 0.0))
                                }
                                user.weekTimeBuckets = []
                                for(let i in this.taskTypes){
                                    user.weekTimeBuckets.push(user.timelogs.filter(t => this.isLastWeek(t.trackedDate)).filter(t => this.getTaskType(t.taskId) == this.taskTypes[i]).map(t => t.hours).reduce(this.add, 0.0))
                                }
                                
                                user.totalPerDay = user.total > 0.0 ? Math.round((user.total / user.totalDays) * 100) / 100 : 0.0
                                user.weekPerDay = user.week > 0.0 ? Math.round((user.week / user.weekDays) * 100) / 100 : 0.0
                                
                                team.totalPerDay += user.totalPerDay
                                team.weekPerDay += user.weekPerDay
                                team.total += user.total
                                team.week += user.week
                                team.yesterday += user.yesterday
                                team.today += user.today
                                team.weekDays += user.weekDays
                                team.totalDays += user.totalDays
                            }
                        }
                        team.radarChartData = this.radarChartData(team)
                        team.lineChartData = this.lineChartData(team)
                    }
                }
                return this.teams
            }
        },
        methods: {
            lineChartData(team){
                if(!team) return null
                let chartData = {
                    labels: this.getDateLabels,
                    datasets: []
                }
                for(let u in team.users){
                    let user = this.users[team.users[u]]
                    let c = [this.getRandomColor(), this.getRandomColor(), this.getRandomColor()]
                    let dataset = {
                        label: `${user.wrike.firstName} ${user.wrike.lastName}`,
                        data: [],
                        lineTension: 0.1,
                        //backgroundColor:`rgba(${c[0]}, ${c[1]}, ${c[2]}, 0.2)`,
                        borderColor: `rgb(${c[0]}, ${c[1]}, ${c[2]})`,
                    }
                    let currentDate = this.start.clone()
                    let invoiceHours = 0.0
                    user.timelogs.sort((a, b) => moment(a.trackedDate).format('YYYYMMDD') - moment(b.trackedDate).format('YYYYMMDD'))
                    for(let i in user.timelogs){
                        let timelog = user.timelogs[i]
                        while(currentDate.format("YYYY-MM-DD") != timelog.trackedDate && currentDate.format("YYYY-MM-DD") != this.end.format("YYYY-MM-DD")){
                            //console.log("Adding info for date: " + currentDate.format("YYYY-MM-DD") + " " + timelog.trackedDate + " ammount : " + invoiceHours + " user: " + user.wrike.firstName)
                            dataset.data.push(invoiceHours)//{x:currentDate.format("DD.MM.YYYY"), y:invoiceHours})
                            
                            invoiceHours = 0.0
                            currentDate.add(1, 'day')
                        }
                        if(this.getTaskType(timelog.taskId) == this.taskTypes[0] || this.getTaskType(timelog.taskId) == this.taskTypes[1]){
                            invoiceHours += timelog.hours
                        }
                    }
                    chartData.datasets.push(dataset)
                }
                return chartData
            },
            radarChartData(team){
                if(!team) return null
                let chartData = {
                    labels: [...this.taskTypes],
                    datasets: []
                }
                // Switch Ikke fakturerbar with Fastpris.
                chartData.labels[2] = this.taskTypes[1] + " x20"
                chartData.labels[1] = this.taskTypes[2] + " x2"
                chartData.labels[3] += " x20"
                chartData.labels[4] += " x2"
                for(let u in team.users){
                    let user = this.users[team.users[u]]
                    // random color
                    let c = [this.getRandomColor(), this.getRandomColor(), this.getRandomColor()]
                    let dataset = {
                        label: `${user.wrike.firstName} ${user.wrike.lastName}`,
                        data: [
                            user.timelogs.filter(t => this.getTaskType(t.taskId) == this.taskTypes[0]).map(t => t.hours).reduce(this.add, 0.0),
                            2 * user.timelogs.filter(t => this.getTaskType(t.taskId) == this.taskTypes[2]).map(t => t.hours).reduce(this.add, 0.0),
                            20 * user.timelogs.filter(t => this.getTaskType(t.taskId) == this.taskTypes[1]).map(t => t.hours).reduce(this.add, 0.0),
                            20 * user.timelogs.filter(t => this.getTaskType(t.taskId) == this.taskTypes[3]).map(t => t.hours).reduce(this.add, 0.0),
                            2 * user.timelogs.filter(t => this.getTaskType(t.taskId) == this.taskTypes[4]).map(t => t.hours).reduce(this.add, 0.0)
                        ],
                        backgroundColor: `rgba(${c[0]}, ${c[1]}, ${c[2]}, 0.2)`,
                        borderColor: `rgb(${c[0]}, ${c[1]}, ${c[2]})`,
                        pointBackgroundColor: `rgb(${c[0]}, ${c[1]}, ${c[2]})`,
                        pointBorderColor: "#fff",
                        pointHoverBackgroundColor: "#fff",
                        pointHoverBorderColor: `rgb(${c[0]}, ${c[1]}, ${c[2]})`,
                    }
                    chartData.datasets.push(dataset)
                }
                
                return chartData
            },
            getRandomColor(){
                return Math.round(Math.random() * 255)
            },
            add(t, a){ return t + a },
            isLastWeek(date){
                let mDate = moment(date, 'YYYY-MM-DD')
                let result = moment().diff(mDate, 'day') < 7
                //console.log(date + " " + result)
                return result
            },
            getData(refresh){
                let url = "/teams/mine"
                url += "?start=" + this.start.format("DD.MM.YYYY")
                url += "&end=" + this.end.format("DD.MM.YYYY")
                if(this.$route && this.$route.query && this.$route.query.user) url += "&user=" + this.$route.query.user
                if(refresh) localStorage.removeItem(url)
                this.loading = true
                api.GET(url)
                    .then(data => {
                        this.users = {}
                        for(let i in data.users){
                            let user = data.users[i]
                            user.timelogs = []
                            this.$set(this.users, user.wrike.id, user)
                        }
                        
                        for(let i in data.timelogs.data){
                            let timelog = data.timelogs.data[i]
                            let user = this.users[timelog.userId]
                            if(user){
                                user.timelogs.push(timelog)
                            }
                        }
                        this.getMissingTasks(data.timelogs.data, refresh)
                        this.teams = data.teams
                        this.loaded = data.loaded
                    }).finally(() => this.loading = false)
            }
        },
        created(){
            this.getData()
        },
        watch: {
            '$route.query.user'(){
                this.getData()
            }
        }
    }
</script>